import React from 'react';
import Snavbar from '../components/JSX/Snavbar';
import Slider4 from '../components/JSX/Slider4';
import Overview from '../components/JSX/Overview';
import Process from '../components/JSX/Process';
import Footers2 from '../components/JSX/Footers2';
import Case from '../components/JSX/Case';

const Risk = () => (
  <>
    <Snavbar />
    <Slider4 />
    <Overview />
    <Process />
    <Case />
    <Footers2 />
  </>
);

export default Risk;